import { render, staticRenderFns } from "./FavoritesBlockForm.vue?vue&type=template&id=55949ae6&scoped=true&"
import script from "./FavoritesBlockForm.vue?vue&type=script&lang=js&"
export * from "./FavoritesBlockForm.vue?vue&type=script&lang=js&"
import style0 from "./FavoritesBlockForm.vue?vue&type=style&index=0&id=55949ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55949ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VCardTitle,VCheckbox,VChip,VIcon,VSelect})
